import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as staffService from "../../services/subAdmin.services";
import Breadcrums from "../../common/breadcrumbs";
import { capitalizeFirstLetter, formateDateWithMonth } from "../../../../utils/commonfunction";
import { Placeholder } from "rsuite";

const SubAdminView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Sub Admins", url: "/admin/staff/list/1" },
    { title: "View", url: "" },
  ];

  useEffect(() => {
    staffService.Details(params.id).then((response) => {
      setData(response?.data || {});
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [params.id]);

  if (loading) {
    return (
      <>
        <Breadcrums data={breadcrumbs} />
        <div className="card custom-card"><div className="card-body"><Placeholder.Paragraph rows={6} active /></div></div>
      </>
    );
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Sub Admin Details</h6>
              <button className="btn btn-secondary btn-sm" onClick={() => navigate("/admin/staff/list/1")}>
                Back
              </button>
            </div>

            <div className="row">
              {data.profile_image && (
                <div className="col-12 mb-3">
                  <img src={data.profile_image} alt="Profile" style={{ height: "80px", width: "80px", borderRadius: "50%", objectFit: "cover" }} />
                </div>
              )}
              <div className="col-md-6 mb-3">
                <label className="fw-bold text-muted small">First Name</label>
                <p className="mb-0">{data.first_name || "N/A"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="fw-bold text-muted small">Last Name</label>
                <p className="mb-0">{data.last_name || "N/A"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="fw-bold text-muted small">Email</label>
                <p className="mb-0">{data.email || "N/A"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="fw-bold text-muted small">Status</label>
                <p className="mb-0">
                  {data.status === 1
                    ? <span className="badge badge-success">Active</span>
                    : <span className="badge badge-secondary">Inactive</span>}
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="fw-bold text-muted small">Role</label>
                <p className="mb-0">{data.permission_role?.title ? capitalizeFirstLetter(data.permission_role.title) : "N/A"}</p>
              </div>
              <div className="col-md-6 mb-3">
                <label className="fw-bold text-muted small">Created Date</label>
                <p className="mb-0">{data.createdAt ? formateDateWithMonth(data.createdAt) : "N/A"}</p>
              </div>

              {data.permission_role?.permissions?.length > 0 && (
                <div className="col-12 mt-2">
                  <label className="fw-bold text-muted small">Permissions</label>
                  <div className="d-flex flex-wrap gap-2 mt-1">
                    {data.permission_role.permissions.map((p) => (
                      <span key={p._id || p.slug} className="badge badge-info">
                        {p.title || p.slug}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubAdminView;
